import instance from 'utils/apiCalls';
import { SUBSIDY_WITHOUT_INCOME_URL } from './SubsidyWithoutIncomeUrls';
import { WithoutIncomeInterface } from '../../../types/interface';

export const createWithoutIncomeConfiguration =
  (
    applicationType: number,
    data: { configurations: WithoutIncomeInterface[] }
  ) =>
  async () => {
    const response = await instance.post(
      `${SUBSIDY_WITHOUT_INCOME_URL.CREATE_WITHOUT_INCOME_CONFIGURATION}/${applicationType}`,
      data
    );
    return response;
  };

export const updateWithoutIncomeConfiguration =
  (
    applicationType: number,
    data: { configurations: WithoutIncomeInterface[] }
  ) =>
  async () => {
    const response = await instance.put(
      `${SUBSIDY_WITHOUT_INCOME_URL.UPDATE_WITHOUT_INCOME_CONFIGURATION}/${applicationType}`,
      data
    );
    return response;
  };

export const getAllWithoutIncomeConfiguration =
  (applicationType: number) => async () => {
    const response = await instance.get(
      `${SUBSIDY_WITHOUT_INCOME_URL.GET_ALL_WITHOUT_INCOME_CONFIGURATION}/${applicationType}`
    );
    return response;
  };

export const getAllApplicationTypeOption = () => async () => {
  const response = await instance.get(
    SUBSIDY_WITHOUT_INCOME_URL.GET_ALL_APPLICATION_TYPE_REQUEST
  );
  return response;
};
